import mql from '../modules/_mediaQueryList'

export default function () {
  const body = document.body
  const trigger = document.getElementById('js-header-trigger')
  const menu = document.getElementById('js-header-menu')

  const changeMedia = () => {
    body.style.position = ''
    body.style.width = ''
    trigger.setAttribute('aria-expanded', 'false')
    menu.setAttribute('aria-hidden', 'true')

    // if (mql.matches) {
    //   menu.setAttribute('aria-hidden', 'true')
    // } else {
    //   menu.removeAttribute('aria-hidden')
    // }
  }
  mql.addEventListener('change', changeMedia)
  changeMedia()

  trigger.addEventListener('click', () => {
    // if (!mql.matches) return

    const isOpen = trigger.getAttribute('aria-expanded') === 'true'

    if (isOpen) {
      close()
    } else {
      open()
    }
  })

  function open() {
    if (mql.matches) {
      // body.style.position = 'fixed'
      // body.style.width = '100%'
      // window.scrollTo({ top: 0 });

      trigger.setAttribute('aria-expanded', 'true')

      menu.style.display = 'grid'
      menu.offsetHeight // reflow
      menu.setAttribute('aria-hidden', 'false')
      menu.style.display = ''
    } else {
      trigger.setAttribute('aria-expanded', 'true')
      menu.setAttribute('aria-hidden', 'false')
    }
  }

  function close() {
    if (mql.matches) {
      body.style.position = ''
      body.style.width = ''
      trigger.setAttribute('aria-expanded', 'false')

      menu.style.display = 'grid'
      const transitionend = () => {
        menu.removeEventListener('transitionend', transitionend)
        menu.style.display = ''
      }
      menu.addEventListener('transitionend', transitionend)
      menu.setAttribute('aria-hidden', 'true')
    } else {
      trigger.setAttribute('aria-expanded', 'false')
      menu.setAttribute('aria-hidden', 'true')
    }
  }
}
